import React from 'react'
import carousalImage from './carousalImageTwo.jpg'
export default function Carousal() {
    return (
        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="false">
          
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src={carousalImage} class="d-block w-100" alt="..."/>
                        <div class="carousel-caption d-md-block">
                            <h1>Our Travel Platform</h1>
                            <h4>For All Your Travel Need</h4>
                        </div>
                </div>
              
            </div>
           
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/carousal.jsx